import { Vue, i18n } from "Common/vue";

import ShippingInfo from "./../components/src/ShippingInfo.vue";

import "../layouts/default";

import "../components/tabs";
import "../components/slider";
import "../components/more-items";
import "../components/favorite-trigger";

import "../common/modal/modal-remote";
import "../common/modal/modal-watchdog";
import "../common/lightgallery";
import "../common/anchor";
import { initCountdowns } from "../common/countdown";

import "../components/rating";

document
  .querySelectorAll('[data-has-component="shippingInfo"]')
  .forEach((element) => {
    new Vue({
      el: element,
      components: {
        ShippingInfo,
      },
    });

    element.removeAttribute("data-has-component");
  });

if (document.querySelector(".js-countdown")) {
  initCountdowns();
}

// const adjustIframeScrollHeight = (iframe) => {
//     iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`
// }
// for (const descriptionIframe of document.querySelectorAll('.js-product-description-iframe')) {
//     descriptionIframe.addEventListener('load', (event) => {
//         descriptionIframe.closest('.js-product-description-iframe-holder').classList.remove('is-loading')

//         // interval, because there are multiple things that can change height of the iframe content
//         // we cannot possibly check for all the changes, thus interval
//         setInterval(() => {
//             adjustIframeScrollHeight(descriptionIframe)
//         }, 1000 / 24) // 24 fps
//         adjustIframeScrollHeight(descriptionIframe)
//     })
//     descriptionIframe.src = descriptionIframe.dataset.src
// }

const productFloater = document.querySelector(".product-floater");
const productInfo = document.querySelector(".product-main__content");

const productFloaterObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        productFloater.classList.remove("is-active");
      } else {
        productFloater.classList.add("is-active");
      }
    });
  },
  {
    threshold: 0,
    rootMargin: "-60px 0px 0px 0px",
  }
);

productFloaterObserver.observe(productInfo);
